import React from 'react'
import { Link } from 'react-router-dom'
import { translate } from '../../assets/js/functions'
import IcoBack from "../../assets/img/ico-tornar.svg";

export default function HomeButton(props) {
    return (
    <Link to={'/home'} className="home-link is-lowercase is-flex is-align-items-center gap-2 px-5 py-4 has-background-white has-text-black has-text-weight-black link-dn is-size-11">
        <img loading="lazy" src={IcoBack} alt="" width="47" height="34" className="is-flex-shrink-0"/>
        {translate('Torna a la portada')}
    </Link>
    )
}
